<template>
  <div class="page-main">
    <e-tabs :list="pageList" :activeVal.sync="lei_mu_lei_xing" />
    <div class="flex flex-y-center m-b-10">
      <el-button type="success" size="mini" @click="itemDo(lei_mu_lei_xing)">新增商品</el-button>
    </div>

    <!-- 表格 -->
    <vxe-grid ref="refTable" v-bind="tableOptions">
      <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_dan_wei="{ row }">
        {{ $tool.getDanWei(row.dan_wei) }}
      </template>
      <template #default_create_date="{ row }">
        {{ row.create_date ? row.create_date.slice(0, 10) : '' }}
      </template>
      <template #default_operate="{ row }">
        <el-link type="primary" @click="itemDo(row.lei_mu_lei_xing, row.id)">编辑</el-link>
        <el-link type="danger" @click="itemDelete(row)">删除</el-link>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="tableOptions.pagerConfig" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-增改商品 -->
    <PopupDoShangPin
      v-if="isShowPopupDoShangPin"
      :show.sync="isShowPopupDoShangPin"
      :detailType="detailType"
      :detailId="detailId"
      @success="searchListData"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupDoShangPin: () => import('./common/popup-do-shang-pin')
  },
  data() {
    return {
      pageList: [
        {
          key: '自建商品',
          val: '原料',
          count: ''
        },
        {
          key: '其他商品',
          val: '商品',
          count: ''
        }
      ],
      lei_mu_lei_xing: '原料',
      filterData: {
        lei_mu_lei_xing: '原料',
        category1: '',
        category2: '',
        category3: '',
        category4: '',
        texture: '',
        mu_ban_ming_cheng: '',
        shang_pin_ming_cheng: '',
        shang_pin_guan_jian_ci: '',
        id: '',
        gui_ge_shi_li: '',
        dan_wei: '',
        zong_shu_liang: '',
        dan_jia: '',
        zong_jin_e: '',
        create_name: '',
        create_date: ''
      },
      detailId: '',
      detailType: '',
      isShowPopupDoShangPin: false,
      headerFilterUrl: '/admin/gcvip/products/searchHeard',
      tableOptions: {
        loading: false,
        size: 'mini',
        border: true,
        height: this.$util.getViewHeight() - 36 - 186,
        pagerConfig: {
          ...this.$constant.page
        },
        columns: [
          { field: 'category1', title: '一级类目', slots: { header: 'header_input' } },
          { field: 'category2', title: '二级类目', slots: { header: 'header_input' } },
          { field: 'category3', title: '三级类目', slots: { header: 'header_input' } },
          { field: 'category4', title: '四级类目', slots: { header: 'header_input' } },
          { field: 'texture', title: '材质', slots: { header: 'header_input' } },
          { field: 'mu_ban_ming_cheng', title: '模板名称', slots: { header: 'header_input' } },
          { field: 'shang_pin_ming_cheng', title: '商品名称', slots: { header: 'header_input' } },
          {
            field: 'shang_pin_guan_jian_ci',
            title: '商品关键词',
            slots: { header: 'header_input' }
          },
          { field: 'id', title: '商品编码', slots: { header: 'header_input' } },
          { field: 'gui_ge_shi_li', title: '规格', slots: { header: 'header_input' } },
          {
            field: 'dan_wei',
            title: '单位',
            slots: { default: 'default_dan_wei', header: 'header_input' }
          },
          { field: 'zong_shu_liang', title: '数量', slots: { header: 'header_input' } },
          { field: 'dan_jia', title: '单价(元)', slots: { header: 'header_input' } },
          { field: 'zong_jin_e', title: '金额(元)', slots: { header: 'header_input' } },
          { field: 'create_name', title: '创建人', slots: { header: 'header_input' } },
          {
            field: 'create_date',
            title: '创建时间',
            slots: { header: 'header_input', default: 'default_create_date' }
          },
          { title: '操作', slots: { default: 'default_operate' } }
        ],
        data: []
      }
    }
  },
  watch: {
    lei_mu_lei_xing(val) {
      this.toggleTab(val)
    }
  },
  mounted() {
    this.searchListData()
  },
  methods: {
    // 切换tab
    toggleTab(val) {
      this.lei_mu_lei_xing = val
      this.filterData.lei_mu_lei_xing = val
      this.searchListData()
    },
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.tableOptions.pagerConfig.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.tableOptions.loading = true
      let filterData = {}
      Object.keys(this.filterData).forEach((key) => {
        if (this.filterData[key]) filterData[key] = this.filterData[key]
      })
      filterData.lei_mu_lei_xing = this.lei_mu_lei_xing
      this.$api({
        method: 'post',
        url: '/admin/gcvip/products/list',
        data: {
          currentPage: this.tableOptions.pagerConfig.currentPage,
          pageSize: this.tableOptions.pagerConfig.pageSize,
          filterData,
          sortData: { id: 'desc' }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.pageList[0].count = res.data.zi_jian_shang_pin_count
            this.pageList[1].count = res.data.qi_ta_shang_pin_count
            this.tableOptions.data = res.data.page.list
            this.tableOptions.pagerConfig.pageSize = res.data.page.pageSize
            this.tableOptions.pagerConfig.total = res.data.page.totalRow
            this.tableOptions.pagerConfig.currentPage = res.data.page.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.tableOptions.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.tableOptions.pagerConfig.currentPage = currentPage
      this.tableOptions.pagerConfig.pageSize = pageSize
      this.getListData()
    },
    // 项-增改
    itemDo(type, id = '') {
      this.detailType = type
      this.detailId = id
      this.isShowPopupDoShangPin = true
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/products/delete',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
